<template>
	<v-hover v-slot="{ hover }" close-delay="200" open-delay="200">
		<component
			:is="tag"
			:width="width"
			:rowspan="rowspan"
			:colspan="colspan"
			:style="componentStyle"
			:class="['editable-cell', className]"
		>
			<p v-if="!editable" v-text="value" :style="paragraphStyle" />
			<template v-else-if="showForm">
				<p v-text="value" :style="paragraphStyle" />
				<v-list class="pa-2 pt-4 top-border edit-dialog hide-print" elevation="3">
					<v-form ref="form" @submit.prevent>
						<v-textarea v-if="text" v-model="newValue" dense outlined />
						<v-text-field v-else v-model="newValue" dense outlined />
						<v-row class="flex-nowrap" justify="center" no-gutters>
							<v-btn color="secondary" class="grow" @click.stop="setValue"> 保存 </v-btn>
							<v-btn text color="grey" justify-self="end" @click.stop="closeEditForm">
								キャンセル
							</v-btn>
						</v-row>
					</v-form>
				</v-list>
			</template>
			<template v-else>
				<p v-text="value" :style="paragraphStyle" />
				<v-btn
					v-show="hover"
					x-small
					absolute
					icon
					class="hide-print"
					@click.stop="showForm = true"
					:style="{ top: 0, right: 0 }"
					><v-icon>mdi-pencil</v-icon></v-btn
				>
			</template>
		</component>
	</v-hover>
</template>

<script>
export default {
	props: {
		value: {
			type: null,
			required: false,
			default: null,
		},
		rowspan: {
			type: Number,
			required: false,
		},
		colspan: {
			type: Number,
			required: false,
		},
		width: {
			type: null,
			required: false,
			default: "",
		},
		className: {
			type: null,
			required: false,
		},
		componentStyle: {
			type: Object,
			required: false,
		},
		paragraphStyle: {
			type: Object,
			required: false,
		},
		tag: {
			type: null,
			required: false,
			default: "td",
		},
		editable: {
			type: Boolean,
			required: false,
			default: true,
		},
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			newValue: null,
			showForm: false,
		}
	},
	mounted() {
		this.newValue = this.value
	},
	methods: {
		setValue() {
			this.$emit("update-value", this.newValue)
			this.closeEditForm()
		},
		closeEditForm() {
			this.showForm = false
		},
	},
	computed: {},
	watch: {
		value: {
			handler(newVal) {
				this.value = newVal
				this.newValue = newVal
			},
		},
		deep: true,
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

.top-border {
	border-top: 8px solid $sub-color;
}
p {
	white-space: pre-wrap;
	max-width: 100%;
	max-height: 100px;
	overflow-y: scroll;
}
.edit-dialog {
	position: absolute;
	z-index: 100;
}
.editable-cell {
	position: relative;
}
.edit-btn {
	top: 0.5rem;
	right: 0.5rem;
	background-color: white;
}

@media print {
	.hide-print {
		display: none;
	}
}
</style>